import { ClipboardApi } from 'src/common/components/ContextualStudioApi';

export const browserClipboardApi: ClipboardApi = {
  writeText: () => document.execCommand('copy', false),
};
